<script setup lang="ts">
import useCmd from "@/composables/useCmd";
import { ButtonNormal, ModalDelete } from "lorga-ui";
import { toRefs } from "vue";

const props = defineProps<{
  query: () => void;
  belegId: string;
  beschreibung: string;
  betrag: number;
}>();
const { query } = toRefs(props);

const { commandModalOpen, commandRequest } = useCmd(query);
</script>

<template>
  <ButtonNormal kind="delete" @click="commandModalOpen = true">
    <ModalDelete
      v-model="commandModalOpen"
      submit="Löschen"
      title="Beleg Löschen"
      :data="{
        action: 'beleg.entfernen',
        beleg_id: belegId,
      }"
      :request="commandRequest"
    >
      Soll der Beleg '{{ beschreibung }}' mit dem Betrag '{{ betrag }}' wirklich
      gelöscht werden?
    </ModalDelete>
    Löschen
  </ButtonNormal>
</template>
